import { useCallback } from "react";

import { useNotify } from "data/messages/hooks";

import { useMutationWithToaster } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

export function useUpdateCommentAssociation(
  commentGid,
  onDone = () => {},
  taskUuid = undefined,
  clientWorkflowUuid = undefined
) {
  const mutationFactory = useCallback(() => {
    const query = `mutation updateCommentAssociation($commentGid: ID!, $taskUuid: UUID, $clientWorkflowUuid: UUID) {
        updateCommentAssociation(commentGid: $commentGid, taskUuid: $taskUuid, clientWorkflowUuid: $clientWorkflowUuid) {
            successMessage
        }
    }`;

    const resolver = ({ data, errors }) => {
      return {
        data: data.updateCommentAssociation,
        errors: errors,
      };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const notifyClientCardTasks = useNotify("CLIENT_CARD_TASKS");
  const [mutation, { loading }] = useMutationWithToaster(mutationFactory, {
    onDone: useCallback(() => {
      notifyClientCardTasks([true]);
      onDone();
    }, [notifyClientCardTasks, onDone]),
  });

  return {
    isUpdatingAssociation: loading,
    updateAssociation: commentGid
      ? async () => {
          return mutation(
            {
              commentGid: commentGid,
              taskUuid: taskUuid,
              clientWorkflowUuid: clientWorkflowUuid,
            },
            {
              successMsg: "Successfully updated comment association.",
              defaultErrorMsg: "Failed to update comment association.",
            }
          );
        }
      : () => {},
  };
}

export default useUpdateCommentAssociation;
